import { defineMessages } from "react-intl";

const PREFIX = "BulkExportPage";
export const messages = defineMessages({
  emailPlaceholder: {
    id: `${PREFIX}.emailPlaceholder`,
    defaultMessage: "Email",
  },
});
